import _ from 'lodash'
import { Icon, C } from 'xadmin-ui'
import { app, api, use } from 'xadmin'
import { SchemaForm } from 'xadmin-form'
import React, { useState, useEffect } from 'react'
import {
  Drawer, Button, Space, message, List, Popconfirm, Row, Col,
  Tooltip, Input, Collapse, Select, Form, Modal, Radio, Menu, Dropdown, Popover
} from 'antd'
import { PaperClipOutlined, PushpinFilled, PushpinOutlined, LinkOutlined } from '@ant-design/icons'
{/* <PushpinOutlined /> */ }
{/* <PushpinFilled /> */ }
const { Search } = Input
const { Option } = Select

const DrawerModal = props => {
  const { getParams, filter, params, type, defaultFilterFlag } = props
  let [ visible, setVisible ] = useState(false)
  let [ items, setItems ] = useState([])
  let [ showModal, setShowModal ] = useState(false)
  let [ initValue, setInitValue ] = useState()
  let [ data, setData ] = useState({ self: [], other: [] })

  let { user } = use('redux', state => ({ user: state.user }))
  let modelDispatch

  try {
    modelDispatch = use('model')?.modelDispatch
  } catch (err) {
    console.error(err)
  }
  const defaultFilter = {
    skip: 0, limit: 10000,
    project: { name: 1, permission: 1, params: 1, showMode: 1, chartMode: 1, creator: 1, default: 1, filter: 1 },
    filter: { type },
    withCount: true
  }
  const showDrawer = () => {
    setVisible(true)
    querydata(defaultFilter)
  }

  const deleteRecord = id => {
    api({ name: `core/dataRecord/${id}` })
      .fetch('', { method: 'DELETE' })
      .then(({ status }) => {
        if (status == 200) {
          message.success('删除成功！')
          showDrawer()
        }
      })
      .catch(err => message.error(err.message,err?.detail))
  }

  const editRecord = item => {
    setShowModal(true)
    setInitValue(item)
  }

  const handleSearch = value => {
    let str = {
      skip: 0, limit: 10000,
      project: { name: 1, permission: 1, params: 1, showMode: 1, chartMode: 1, creator: 1, default: 1 },
      filter: { name: { '$regex': value } },
      withCount: true
    }

    // 根据类型查询不同记录
    if (type) {
      str['filter']['type'] = type
    }
    querydata(str)
  }


  const querydata = (filters) => {
    const querystr = encodeURIComponent(JSON.stringify(filters))
    api({ name: 'core/dataRecord' })
      .fetch('?query=' + querystr, {})
      .then(({ json }) => {
        setData({
          ...data,
          self: json?.length ? json.filter(item => item?.permission?.permissionType == 'self').reverse() : [],
          other: json?.length ? json.filter(item => item?.permission?.permissionType != 'self').reverse() : []
        })
        setItems(json)
      })
      .catch(err => message.error(err.message,err?.detail))
  }


  const pushpinClick = (boolean, item) => {
    function query(id, body) {
      api({ name: 'core/dataRecord' })
        .fetch(`/${id}`, { method: 'PATCH', body: JSON.stringify(body) })
        .then(({ status }) => {
          status == 200 && querydata(defaultFilter)
        })
    }

    const defaultObj = items.filter(opt => opt.default && opt.default.length > 0 && opt.default.indexOf(user.id) != -1)[0]
    if (defaultObj && defaultObj.id) {
      if (_.isArray(defaultObj?.default)) {
        query(defaultObj.id, { 'default': defaultObj?.default.filter(id => id != user.id) })
      }
    }
    query(item.id, { 'default': boolean ? [ ...item.default || [], user.id ] : item?.default.filter(id => id != user.id) })

  }

  const item_props = { user, setVisible, deleteRecord, editRecord, getParams, modelDispatch, pushpinClick, defaultFilterFlag }

  return (
    <>
      <Tooltip title="查询记录">
        <Button style={{ marginRight: '.3rem' }} icon={<PaperClipOutlined />} type="primary" onClick={() => showDrawer()} />
      </Tooltip>
      <Drawer
        key="right"
        width={450}
        title="记录管理"
        closable={true}
        placement="right"
        visible={visible}
        onClose={() => setVisible(false)}
        bodyStyle={{ marginTop: '3.6rem' }}
      >
        <Search
          enterButton
          placeholder="搜索名称记录"
          notFoundContent={<C is="NoData" />}
          onSearch={value => handleSearch(value)}
          style={{ padding: '0 24px', position: 'absolute', top: '80px', left: 0, width: '100%', height: '32px' }}
        />
        <Collapse defaultActiveKey={[ 'self', 'other' ]}>
          <Collapse.Panel header="个人" key="self">
            <List
              locale={{ emptyText: <C is="NoData" /> }}
              bordered
              dataSource={data.self}
              renderItem={item => <ListItemsComponent item={item} {...item_props} type={type} />}
            />
          </Collapse.Panel>
          <Collapse.Panel header="其他" key="other">
            <List
              locale={{ emptyText: <C is="NoData" /> }}
              bordered
              dataSource={data.other}
              renderItem={item => <ListItemsComponent item={item} {...item_props} type={type} />}
            />
          </Collapse.Panel>
        </Collapse>
        <AddHistoryModal
          filter={filter}
          mask={false}
          params={params}
          visible={showModal}
          initValue={initValue}
          uploadValue={() => showDrawer('upload')}
          changeViseble={() => setShowModal(false)}
        />
      </Drawer>
    </>
  )

}

const ListItemsComponent = (props) => {
  const { item, user, deleteRecord, editRecord, getParams, setVisible, modelDispatch, pushpinClick, defaultFilterFlag, type } = props
  const creator = item?.creator || {}
  const projecctId = api({ name: 'media' }).headers['x-request-project']
  const origin = window.location.origin + (projecctId ? '/_p_' + projecctId : '')

  const onViewClick = (item) => {
    if (getParams && _.isFunction(getParams)) {
      getParams(item)
      setVisible(false)
    } else if (modelDispatch && _.isFunction(modelDispatch)) {
      modelDispatch({ type: 'GET_ITEMS', wheres: { ...item.params } })
      setVisible(false)
    } else {
      throw new Error('未定义 getParams 函数或未找到 model');
    }
  }

  const copyLink = value => {
    document.getElementById('search').select();
    const copyStatus = document.execCommand('Copy');
    if (copyStatus) {
      message.success('复制成功');
    } else {
      message.error('复制失败');
    }
  }

  return (<List.Item>
    <Row style={{ width: '100%' }}>
      <Col span={12} style={{ lineHeight: '32px' }}>{item.name}</Col>
      <Col span={12} style={{ textAlign: 'right' }}>
        <Space>
          <Button.Group>
            {
              defaultFilterFlag && <Tooltip title="默认为查询条件">
                {_.isArray(item.default) && item.default.indexOf(user.id) != -1 ?
                  <Button icon={<PushpinFilled />} onClick={() => pushpinClick(false, item)} />
                  : <Button icon={<PushpinOutlined />} onClick={() => pushpinClick(true, item)} />}

              </Tooltip>
            }
            <Tooltip title="查看查询结果">
              <Button icon={<Icon type="eye"></Icon>} onClick={() => onViewClick(item)} />
            </Tooltip>
            {
              ((creator?.id == user?.id) || user.isSuper) &&
              <>
                <Button onClick={() => editRecord(item)} icon={<Icon type="edit"></Icon>} />
                <Popconfirm
                  okText="确定"
                  cancelText="取消"
                  placement="leftBottom"
                  arrowPointAtCenter={true}
                  title="是否确认删除已保存的记录?"
                  onConfirm={() => deleteRecord(item.id)}
                >
                  <Button icon={<Icon type="delete"></Icon>} />
                </Popconfirm>
              </>
            }
            {
              type == 'analysis' ? 
                <Popover
                  placement="leftTop"
                  content={
                    <Search
                      id="search"
                      value={`${origin}#/app/record/${item.id}`}
                      enterButton="复制"
                      onSearch={copyLink}
                    />
                  }
                >
                  <Button icon={<LinkOutlined />} />
                </Popover>
                : null
            }
            {
              type == 'analysis' ? 
                <C is="ShareDashbaord" type={'analysis'} params={ { id: item.id }}/>
              : null
            }
          </Button.Group>
        </Space>
      </Col>
    </Row>
  </List.Item>)
}

const UserMultiple = props => {
  const { getUser, userList } = props
  const [ data, setData ] = useState([])

  useEffect(() => { getUserList() }, [])

  const getUserList = () => {
    let str = { skip: 0, limit: 10000, project: { name: 1, department: 1 }, withCount: true }
    const querystr = encodeURIComponent(JSON.stringify(str))
    api({ name: 'core/user' })
      .fetch('?query=' + querystr, {})
      .then(({ json }) => {
        setData(json)
      })
      .catch(err => message.error(err.message,err?.detail))
  }

  const handleChange = value => {
    if (value && _.isArray(value) && value.length) {
      getUser(value.map(item => ({ id: item.value, name: item.label })))
    }
  }

  return (
    <Select
      allowClear
      labelInValue
      mode="multiple"
      placeholder="请选择用户"
      onChange={handleChange}
      style={{ width: '200px' }}
      filterOption={(input, option) => (
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )}
      defaultValue={_.isArray(userList) && userList.length && userList.map(item => ({ value: item.id, label: item.name })) || []}
    >
      {data.map(item => (<Option value={item.id} key={item.id}>{item.name}</Option>))}
    </Select>
  )
}

const currentDept = id => {
  const querystr = encodeURIComponent(JSON.stringify(
    { skip: 0, limit: 10000, project: { name: 1, department: 1 }, withCount: true }
  ))
  return api({ name: `core/user/${id}` }).fetch('?query=' + querystr, {})
}

const recordPermission = props => {
  const { input: { onChange, value } } = props
  let { state: { user } } = use('redux')
  let [ obj, setObj ] = useState(value)

  const radioStyle = {
    display: 'block',
    // height: '30px',
    // lineHeight: '30px',
  }

  useEffect(() => {
    onChange(obj)
  }, [ JSON.stringify(obj) ])

  const handleChange = e => {
    let radioValue = e.target.value
    if (radioValue) {
      if (user && user.isSuper) {
        setObj({ ...obj, permissionType: radioValue })
      } else {
        if (radioValue == 'dept') {
          currentDept(user.id)
            .then(({ json }) => {
              setObj({ permissionType: radioValue, department: json && json.department })
            })
            .catch(err => message.error(err.message,err?.detail))
        } else {
          setObj({ permissionType: radioValue })
        }
      }
    }
  }

  return (
    <Radio.Group onChange={handleChange} value={obj && obj.permissionType || ''}>
      {
        user && user.isSuper ? (
          <>
            <Radio style={radioStyle} value="self">仅自己可见</Radio>
            <Radio style={radioStyle} value="public">公开</Radio>
            <Space style={{ width: '100%' }}>
              <Radio style={radioStyle} value="dept">按部门</Radio>
              {
                obj && obj.permissionType == 'dept' && <C is="DepartmentMultipleSelectField"
                  input={{
                    value: value.department,
                    onChange: (value) => setObj({ ...obj, department: value })
                  }}
                />
              }
            </Space>
            <Space style={{ width: '100%' }}>
              <Radio style={radioStyle} value="user">指定用户</Radio>
              {
                obj && obj.permissionType == 'user' && <UserMultiple
                  userList={value.user}
                  getUser={(value) => setObj({ ...obj, user: value })}
                />
              }
            </Space>
          </>
        ) : (
          <>
            <Radio style={radioStyle} value="self">仅自己可见</Radio>
            <Radio style={radioStyle} value="public">公开</Radio>
            <Radio style={radioStyle} value="dept">本部门</Radio>
          </>
        )
      }
    </Radio.Group>
  )
}

const recordSchema = {
  type: 'object',
  properties: {
    name: {
      title: '记录名称',
      type: 'string'
    },
    permission: {
      title: '记录权限',
      type: 'object'
    }
  },
  form: [ '*', { key: 'permission', component: recordPermission } ],
  required: [ 'name', 'permission' ]
}

const DefaultLayout = props => {
  const { children, invalid, handleSubmit, onDelete, schema, submitting, hideModal } = props;
  const { _t } = app.context

  return (
    <Form className="form-horizontal voucherBox" onSubmit={handleSubmit}>
      { children}
      <div style={{ textAlign: 'right', marginTop: '2.2rem' }}>
        <Space>
          <Button
            type="primary"
            onClick={handleSubmit}
            disabled={invalid}
          >
            {_t('确认')}
          </Button>
          <Button onClick={() => { hideModal() }}>取消</Button>
        </Space>
      </div>
    </Form>
  )
}

const AddHistoryModal = props => {
  const { visible, changeViseble, initValue, uploadValue, params, mask, filter = {}, type } = props
  let id = initValue && initValue.id

  const getValue = (value, id) => {
    let newData;
    if (value && value.permission && value.permission.permissionType) {
      let permissionType = value.permission.permissionType
      switch (permissionType) {
        case 'self':
          newData = { ...value, permission: { permissionType } }
          break;
        case 'public':
          newData = { ...value, permission: { permissionType } }
          break;
        case 'dept':
          newData = { ...value, permission: { permissionType, department: value.permission.department } }
          break;
        case 'user':
          newData = { ...value, permission: { permissionType, user: value.permission.user } }
          break;
      }
    }

    if (id) {
      eidtValue(newData, id)
    } else {
      let obj = { ...newData, params }

      if (type) {
        obj['type'] = type
      }
      if (JSON.stringify(filter) != '{}') {
        obj['filter'] = filter
      }

      api({ name: 'core/dataRecord' })
        .fetch('', { method: 'POST', body: JSON.stringify(obj) })
        .then(res => {
          message.success('保存成功！')
          changeViseble()
        })
        .catch(err => {
          message.error(err.message,err?.detail)
        })
    }
  }

  const eidtValue = (value, id) => {
    api({ name: `core/dataRecord/${id}` })
      .fetch('', { method: 'PATCH', body: JSON.stringify(value) })
      .then(res => {
        message.success('修改成功！')
        changeViseble()
        uploadValue()
      })
      .catch(err => {
        message.error(err.message,err?.detail)
      })
  }

  return (
    <Modal
      title="添加记录"
      visible={visible}
      onCancel={() => changeViseble()}
      footer={null}
      mask={mask}
    >
      <SchemaForm
        formKey={'anslysisCondition' + Math.random().toFixed(2)}
        schema={recordSchema}
        component={DefaultLayout}
        initialValues={initValue ? initValue : {}}
        onSubmit={(value) => getValue(value, id)}
        hideModal={() => changeViseble()}
      />
    </Modal>
  )
}


/** 
 * @param {string} type   存贮模块分类
 * @param {object} params   要保存的查询条件及权限
 * @param {object} filter   可传其他参数
 * @param {function} getParams  回调函数form复值
 */

const FiltersHistory = (props) => {
  let type = props && props.type
  let getModelState
  let { params } = props

  const [ visible, setVisible ] = useState(false)
  const [ wheres, setWheres ] = useState({})

  if (!params) {
    try {
      getModelState = use('model')['getModelState']
      type = use('model')['model']['name']
    } catch (err) {
      console.error(err)
    }
  }

  // 保存自己传的参数或者redux上的查询条件
  const onSave = () => {
    if (params) {
      setWheres(params)
    } else {
      _.isFunction(getModelState) && setWheres(getModelState()?.wheres)
    }
    setVisible(true)
  }

  return (
    <Space size={5}>
      <Tooltip title="可将查询条件保存记录，方便下次查询。">
        <Button type="primary" onClick={onSave}>
          保存查询记录
        </Button>
      </Tooltip>
      <DrawerModal  {...props} params={wheres} type={type} />
      <AddHistoryModal
        {...props}
        mask={true}
        type={type}
        params={wheres}
        visible={visible}
        changeViseble={() => { setVisible(false) }}
      />
    </Space>
  )
}


export default FiltersHistory
